import axios from '../axios';

const getProjectTelegramBots = async (projectId: string) => {
  const { data } = await axios.get(`/telegram-bots/${projectId}`);

  return data;
};

export default getProjectTelegramBots;
